import * as React from 'react';
import { connect } from 'react-redux';
import * as qs from 'qs';
import { pageWrapper, EEventNames } from '../../../../../client/analytics';
import Spinner from '../../../../common/components/spinner';
import Container from '../../../../common/components/container';
import OnboardingForm from '../../forms/onboarding';
import * as userSelector from '../../../core/selectors/logged-user';
import fetchProfileAction from '../../../core/actions/fetch-profile';

class OnboardingContainer extends React.Component {
  static defaultProps = {
    form: {},
  };

  componentDidMount() {
    if (!this.props.loggedUser || !this.props.loggedUser.user) this.props.fetchProfile();
  }

  static props;

  render() {
    const { match: { params }, loggedUser, form, history } = this.props;
    const query = qs.parse(window?.location?.search, { ignoreQueryPrefix: true });
    const orgId = params.organisationId;

    return (
      <Container name="OrganisationOnboarding">
        <Container.Content>
          {loggedUser ? (
            <OnboardingForm
              history={history}
              organisationId={orgId}
              loggedUser={loggedUser}
              formValues={form.values}
              onBack={(
                query.back &&
                (() => history.push('/auth/registration?org=' + orgId))
              )}
            />
          ) : <Spinner size="large" centered />}
        </Container.Content>
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  form: state.form.onboarding,
  loggedUser: userSelector.selected(state),
});

const mapDispatchToProps = {
  fetchProfile: fetchProfileAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(pageWrapper(EEventNames.VISITED_USER_ONBOARDING_PAGE)(OnboardingContainer));
